// Persists the tunable `config` to localStorage so settings survive reloads.
// Lives outside src/sim/ because it touches the DOM (localStorage).

import { config, DEFAULT_CONFIG, GameConfig } from './sim/config';

const KEY = 'blockfall.settings';

export function loadSettings(): void {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    const saved = JSON.parse(raw) as Partial<GameConfig>;
    for (const k of Object.keys(DEFAULT_CONFIG) as (keyof GameConfig)[]) {
      if (typeof saved[k] === 'number') config[k] = saved[k] as number;
    }
  } catch {
    // Corrupt settings — ignore and use defaults.
  }
}

export function saveSettings(): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(config));
  } catch {
    // Storage full / disabled — non-fatal.
  }
}
